<template>
  <div class="chat-container">
    <div
      v-show="isStarsAnimationVisible"
      class="stars-animation"
    />

    <div class="typing-animation">
      <span
        v-html="currentMessage"
        class="message-content"
      />
    </div>

    <span
      v-show="isCursorVisible"
      class="cursor"
    >
      |
    </span>
  </div>
</template>

<script>
  import dateFilter from '@/utils/filters/dateFilter'

  import { mapGetters, mapState } from 'vuex'
  import lottie from 'lottie-web'

  export default {
    name: 'BaseChatTypingIndicator',

    props: ['incomingMessage'],

    data() {
      return {
        isStarsAnimationVisible: true,
        isTypingAnimationVisible: false,
        isCursorVisible: false,
        currentMessage: '',
        typingSpeed: 20,
        completeMessage: '',
        animation: null
      }
    },

    watch: {
      incomingMessage(newMessage, oldMessage) {
        if (newMessage !== oldMessage) {
          this.animateTyping(newMessage)
        }
      }
    },

    computed: {
      ...mapState('base', ['pageFilter']),

      ...mapGetters('smartSummary', ['getFilterTags']),

      filtersText() {
        let filtersTags = this.getFilterTags
        let slicedFiltersTags = filtersTags.slice(1).map(tag => tag.label)
        if (!slicedFiltersTags.length) return ''

        return `e o(s) filtros ${slicedFiltersTags.join(', ')}, `
      },

      defaultText() {
        let text = '<p>'

        text += `Durante o intervalo de `
        text += `${dateFilter(this.pageFilter?.dateRange[0])} `
        text += `até ${dateFilter(this.pageFilter?.dateRange[1])}, `
        text += this.filtersText
        text += `analisamos os principais insights para o seu negócio.`

        text += '</p>'

        return text
      }
    },

    mounted() {
      this.animation = lottie.loadAnimation({
        container: this.$el.querySelector('.stars-animation'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: require('@/assets/img/main/stars-animation.json')
      })
    },

    methods: {
      animateTyping(newMessage) {
        this.isStarsAnimationVisible = true
        this.currentMessage = ''
        this.completeMessage = this.defaultText + newMessage

        this.startTypingAnimation()
      },

      startTypingAnimation() {
        let charIndex = 0
        this.isStarsAnimationVisible = false
        this.isCursorVisible = true

        const interval = setInterval(() => {
          if (charIndex < this.completeMessage.length) {
            this.currentMessage += this.completeMessage.charAt(charIndex)
            charIndex++
          } else {
            clearInterval(interval)
            this.isTypingAnimationVisible = false
            this.isCursorVisible = false
            this.isStarsAnimationVisible = false
          }
        }, this.typingSpeed)
      }
    }
  }
</script>

<style scoped lang="scss">
  .chat-container {
    min-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .typing-animation,
  .chat-message {
    flex: 0 0 auto;
  }

  .stars-animation {
    width: 30px;
    height: 30px;
  }

  .typing-animation {
    position: relative;
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
  }

  .message-content {
    display: inline-block;

    /deep/ {
      h4 {
        font: {
          size: 12px;
          weight: 700;
        }
        line-height: 23px;
        margin-bottom: 4px;
      }

      ul {
        li {
          font: {
            size: 12px;
            weight: 400;
          }
          line-height: 23px;
          margin-bottom: 4px;
        }
      }

      p {
        margin-bottom: 12px;

        font: {
          size: 12px;
          weight: 400;
        }
        line-height: 23px;
      }
    }
  }

  .cursor {
    animation: blink 1s infinite;
    visibility: visible;
  }

  @keyframes blink {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
</style>
